import React from 'react';
import { motion } from 'framer-motion';
import { Play, Youtube, CheckCircle2 } from 'lucide-react';
import './LukosVideoShowcase.css';

const LukosVideoShowcase = () => {
  return (
    <section className="lvs-section">
      <div className="lvs-container">
        <div className="lvs-row">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="lvs-content"
          >
            <p className="mb-5 text-[10px] font-bold uppercase tracking-[0.28em] text-[#7f00ff]">
              •&nbsp;&nbsp;THIAGO NOGUEIRA — LUKOS
            </p>
            <h2 className="text-[26px] sm:text-[32px] lg:text-[36px] font-extrabold leading-[0.95] tracking-tight text-slate-900">
              O Futuro da <span className="text-[#7f00ff]">IA</span> nos Postos e Conveniências.
            </h2>
            <p className="mt-5 max-w-[440px] text-[13.5px] sm:text-[14px] leading-[1.65] text-slate-500">
              Como a Inteligência Artificial está redefinindo a eficiência e a lucratividade
              no varejo de combustível e lojas de conveniência.
            </p>
          </motion.div>

          <motion.div
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
            className="lvs-video-full"
          >
            <div className="lvs-video-frame">
              <iframe
                src="https://www.youtube.com/embed/0HNEfPlfGz0?autoplay=0&rel=0&modestbranding=1&start=15"
                title="YouTube video player"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                allowFullScreen
                className="w-full h-full"
              />
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default LukosVideoShowcase;
